import { getCookie, setCookie, deleteCookie } from "./utilities/cookies";
import { safeJsonParse } from "./utilities/safe-json-parse";
import jwt_decode from "jwt-decode"; 
import { redirectAfterLogin } from "./utilities/redirect-after-login";

const cookieCustomerId = 'foxy-customer-id';
const cookieSessionToken = 'foxy-session-token';

customElements.whenDefined('foxy-customer-portal').then(() => {
    const portals = [...document.getElementsByTagName('foxy-customer-portal')];
    portals.forEach(portal => {
        portal.addEventListener('signin', function () {
            setCustomerIdCookie();
            setSessionTokenCookie();
            redirectAfterLogin();
        });

        portal.addEventListener('signup', function () {
            setCustomerIdCookie();
            setSessionTokenCookie();
            redirectAfterLogin();
        });

        portal.addEventListener('signout', function () {
            deleteCookie(cookieCustomerId);
            deleteCookie(cookieSessionToken);
        });
    });
}); 


export const getCustomerId = () => {
    const foxySession = localStorage.getItem('session');

    const foxySessionStore = safeJsonParse(foxySession);

    if(!foxySessionStore || !foxySessionStore.hasOwnProperty('jwt')) {
        return;
    }

    const decodeJwt = jwt_decode(foxySessionStore.jwt);

    return decodeJwt.customer_id;
}

export const setCustomerIdCookie = () => {
    const customerCookie = getCookie(cookieCustomerId);
    const foxySession = localStorage.getItem('session');
    
    //if the cookie is already set, and the user is not logged in do nothing but remove the cookie
    if(customerCookie === true) {
        if(!foxySession) {
            deleteCookie(cookieCustomerId);
        }
        return;
    }

    const customerId = getCustomerId();

    if(!customerId) {
        return;
    }

    return setCookie(cookieCustomerId, customerId, 1);

};

export const setSessionTokenCookie = () => {
    const customerCookie = getCookie(cookieSessionToken);
    const foxySession = localStorage.getItem('session');
    
    //if the cookie is already set, and the user is not logged in do nothing but remove the cookie
    if(customerCookie === true) {
        if(!foxySession) {
            deleteCookie(cookieSessionToken);
        }
        return;
    }

    //to do - check the session is there, check its json, if not delete cookies
    const foxySessionStore = safeJsonParse(foxySession);

    if(!foxySessionStore || !foxySessionStore.hasOwnProperty('session_token')) {
        return;
    }
    return setCookie(cookieSessionToken, foxySessionStore.session_token, 1);

};